export const REFRESH_REGIONALS = 'REFRESH_REGIONALS';
export const CLEAR_REGIONALS_FILTERS = 'CLEAR_REGIONALS_FILTERS';
export const FILTER_REGIONALS = 'FILTER_REGIONALS';
